<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 703 212"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="gsk" clip-path="url(#clip0_1_128)">
      <g id="Group">
        <path
          id="Vector"
          d="M195.186 85.0058H125.257V98.1786C125.257 113.616 137.597 126.377 153.023 126.377H170.094V160.338C170.094 164.866 166.392 168.365 162.073 168.365H55.9438C49.1565 168.365 43.809 162.808 43.809 156.221V85.0058V55.9845C43.809 49.1922 49.1565 43.8408 55.9438 43.8408H169.888V0H52.653C44.426 0 36.4046 1.85243 29.0003 5.55728C18.7165 10.4971 10.4895 18.9359 5.55325 29.0214C1.85108 36.4311 0 44.4583 0 52.6913V159.309C0 167.542 1.85108 175.569 5.55325 182.979C10.4895 193.27 18.9222 201.503 29.0003 206.443C36.4046 210.148 44.426 212 52.653 212H141.094C157.548 212 170.917 198.621 170.917 182.155V170.217C170.917 169.188 171.739 168.159 172.768 168.159H172.973C196.626 167.542 211.846 156.016 211.846 136.05V85.0058H195.186Z"
          :fill="props.fill"
        />
        <path
          id="Vector_2"
          d="M243.726 82.3301C243.726 109.499 266.35 126.377 297.202 126.377H400.657C406.827 125.965 412.38 130.699 412.791 136.874C412.791 137.491 412.791 137.903 412.791 138.52V156.221C413.203 162.396 408.472 167.953 402.302 168.365C401.685 168.365 401.274 168.365 400.657 168.365H255.038V212H401.891C430.891 212.823 454.955 189.771 455.778 160.75C455.778 159.926 455.778 158.897 455.778 158.074V138.726C456.6 109.705 433.565 85.6233 404.564 84.8C403.742 84.8 402.713 84.8 401.891 84.8H298.641C292.471 85.2117 286.918 80.4777 286.506 74.3029C286.506 73.6854 286.506 73.2738 286.506 72.6563V51.868C286.095 47.7515 289.18 44.0466 293.294 43.8408C293.705 43.8408 294.116 43.8408 294.733 43.8408H438.09V0H315.301C299.053 0 285.684 13.1728 285.478 29.433V41.5767C285.478 42.6058 284.655 43.635 283.627 43.635H283.421C262.442 44.4583 243.726 56.1903 243.726 82.3301Z"
          :fill="props.fill"
        />
        <path
          id="Vector_3"
          d="M491.154 150.047V212H534.757V114.85C534.757 110.528 538.048 109.705 540.516 112.175L643.354 212H703L593.992 106L703 0H643.354L540.516 99.8252C538.048 102.295 534.757 101.472 534.757 97.1495V0H491.154V62.365C491.154 84.8 505.757 98.1786 531.672 105.383C532.7 105.794 532.7 106.823 531.672 107.029C505.757 114.027 491.154 127.612 491.154 150.047Z"
          :fill="props.fill"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_128">
        <rect width="703" height="212" :fill="props.fill" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: 703
  },
  height: {
    type: [Number, String],
    default: 212
  },
  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
